export const cardData = [
  {
    testimonial:
      "Este o idee foarte bună. Sper să fie folosită platforma.Am văzut destule persoane care nu au idee ce și cum să lucreze cu preșcolarii. ",
    name: "Agnes",
    job: 'Educator'
  },
  {
    testimonial: "Platforma îmi este folositoare și cu sigurantă voi face planificarea astfel încât să integreze cât mai multe din activități la grupă",
    name: "Ana",
    job: 'Educator'
  },
  {
    testimonial: "Perfectă pentru dezvoltarea competentelor pre și matematice. Îmi este clar că o voi folosi în fiecare zi!",
    name: "Maria",
    job: 'Educator'
  },

]